

import LocomotiveScroll from 'locomotive-scroll';
import { EC1Map } from './map.js';

const MapService = new EC1Map();


window.InitLocomotiveScroll = function () {

    //if (window.innerWidth > 1200) {
    const imagesLoaded = require("imagesloaded"); // import the library or can use cdn
    let scrollContainer = document.querySelector("[data-scroll-container]");

    let scroll;

    scroll = new LocomotiveScroll({
        el: scrollContainer,
        smooth: true,
        smoothMobile: true,
        getSpeed: true,
        getDirection: true,
        offset: ["15%", 0],
        scrollbarContainer: scrollContainer,
        mobile: {
            breakpoint: 0,
            smooth: true,
            getSpeed: true,
            getDirection: true,
        },
        tablet: {
            breakpoint: 0,
            smooth: true,
            getSpeed: true,
            getDirection: true,
        },
    });

    // scroll.init()


    scroll.on('scroll', scrollOptions => {
        scroll.update();
        ManageNavBar(scrollOptions)
    });
    if (window.locoScroll) {
        window.locoScroll.stop();
        window.locoScroll.destroy();
    }

    new ResizeObserver(() => {
        let elem = document.querySelector("[data-scroll-container]");
        if (window.locoScroll && elem) {
            window.locoScroll.update();
        }

    }).observe(document.querySelector("[data-scroll-container]"))

    window.locoScroll = scroll;
    /* update scroll (height) when all images are loaded */

    imagesLoaded(scrollContainer, { background: true }, function () {
        scroll.update();
    });





}

window.DelayLocoScrollInit = function () {
    if (window.locoScroll) {
        window.locoScroll.destroy();
        window.locoScroll.init();
    }
}
window.LocomotiveScrollTo = function (elementId) {
    const target = document.getElementById(elementId);

    if (window.locoScroll) {
        window.locoScroll.scrollTo(target, {
            offset: window.getOffsetByDevicePixelRatio()
        });
    }
}

window.getOffsetByDevicePixelRatio = function () {
    switch (true) {
        case window.devicePixelRatio == 1:
            return -90;
        case window.devicePixelRatio < 1.5:
            return -78;
        case window.devicePixelRatio >= 1.5:
            return -46;
    }
}

function loadMap(configuration) {
    // Ensure MapDotNetHelper is set before initializing map
    if (!window.MapDotNetHelper) {
        // Retry after a short delay
        setTimeout(() => loadMap(configuration), 50);
        return;
    }

    MapService.initializeMap(configuration.apiKey);
}

// Expose to global window object for C# interop
window.EC1 = {
    loadMap,
    MapService
};

export { loadMap, MapService };